import React from 'react'
import { Box, Flex, Text } from '@chakra-ui/core'
import { ReasonCheckboxItem, ReasonVariant } from './ReasonCheckboxItem'

export interface ReasonItem {
  key: string
  score?: number
  isSelected: boolean
}

interface ReasonsListProps {
  title: string
  reasons: ReasonItem[]
  onToggle: (key: string) => void
  variant?: ReasonVariant
  showScore?: boolean
}

export const ReasonsList: React.FC<ReasonsListProps> = ({ title, reasons, onToggle, variant, showScore }) => {
  return (
    <Box>
      <Text fontSize="14px" fontWeight="600" color="#374151" mb="12px">
        {title}
      </Text>
      <Flex direction="column" style={{ gap: '8px' }}>
        {reasons.map((reason) => (
          <ReasonCheckboxItem
            key={reason.key}
            reasonKey={reason.key}
            isSelected={reason.isSelected}
            onToggle={() => onToggle(reason.key)}
            variant={variant}
            score={reason.score}
            showScore={showScore}
          />
        ))}
      </Flex>
    </Box>
  )
}
